import { AbstractQuery, QueryRequest } from 'src/models/query';

class QueryBuilder {
	public readonly queryStoreURL: string;

	constructor(queryStoreURL: string) {
		this.queryStoreURL = queryStoreURL;
	}

	build(query: AbstractQuery): QueryRequest {
		const serializedQuery = {
			apiVersion: query.apiVersion,
			customPayload:
				query.customPayload.length > 0 ? encodeURIComponent(JSON.stringify(query.customPayload)) : undefined,
			group: JSON.stringify(query.group),
			parameters: encodeURIComponent(JSON.stringify(query.parameters)),
			processId: query.processId,
			query: query.name,
			sort: JSON.stringify(query.sort),
		};

		if (Object.prototype.hasOwnProperty.call(query, 'page')) {
			return new QueryRequest(
				this.queryStoreURL +
					'/query' +
					this.serialize({
						...serializedQuery,
						limit: query.limit ? query.limit : 1000,
						page: query.page ? query.page : 1,
					}) +
					'&format=pako'
			);
		} else {
			return new QueryRequest(this.queryStoreURL + '/query' + this.serialize(serializedQuery) + '&format=pako');
		}
	}

	serialize(query: Record<string, number | string | undefined>): string {
		return (
			'?' +
			Object.keys(query)
				.reduce(function (resultArray: Array<string>, key: string) {
					if (query[key] === undefined) {
						return resultArray;
					}

					resultArray.push(key + '=' + encodeURIComponent(query[key]));
					return resultArray;
				}, [])
				.join('&')
		);
	}
}

export { QueryBuilder };
